import { Normalization } from '~/utils/normalization'

type CurrencyValue = number | string | null | undefined

function resolveCurrencyNumber(value: CurrencyValue): number {
  return Normalization.isFiniteNumber(value) ? value : Number.parseFloat(String(value ?? '')) || 0
}

/**
 * Format a number as currency
 * @param {number|string} value - The value to format
 * @param {string} currency - The currency symbol (default: '$')
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted currency string
 */
export function formatCurrency(value: CurrencyValue, currency = '$', decimals = 2): string {
  const numValue = resolveCurrencyNumber(value)
  return `${currency}${numValue.toFixed(decimals)}`
}
